import BaseReducer from "./BaseReducer";

class LoadingReducer extends BaseReducer {
  domain = "Loading";
  type = "Spinner";

  initialState = {
    loading: false,
  };
}

const reducer = new LoadingReducer();

export default reducer;
